import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Menu Section */}
        <div className="footer-section">
          <h3>Menu</h3>
          <ul>
            <li>
              <a href="/">
                <i className="bi bi-house-door" style={{ marginRight: "8px" }}></i> Home
              </a>
            </li>
            <li>
              <a href="/places">
                <i className="bi bi-geo-alt" style={{ marginRight: "8px" }}></i> Places to Go
              </a>
            </li>
            <li>
              <a href="/things">
                <i className="bi bi-binoculars" style={{ marginRight: "8px" }}></i> Things to Do
              </a>
            </li>
          </ul>

        </div>

        {/* Links Section */}
        <div className="footer-section">
          <h3>Follow Bacoor</h3>
          <ul>
            <li>
              <i className="bi bi-facebook"></i>
              <a href="https://www.facebook.com/CityGovtBacoor/?ref=embed_page" target="_blank" rel="noopener noreferrer">
                City Government of Bacoor
              </a>
            </li>
            <li>
              <i className="bi bi-twitter"></i>
              <a href="https://x.com/CityofBacoor?t=wdE3WoosPgN66P9zg8rpUA&s=09" target="_blank" rel="noopener noreferrer">
                City of Bacoor
              </a>
            </li>
            <li>
              <i className="bi bi-instagram"></i>
              <a href="https://www.instagram.com/citygovtbacoor?igsh=bzZiY2VmbWppZ3c4" target="_blank" rel="noopener noreferrer">
                City Government Bacoor
              </a>
            </li>
            <li>
              <i className="bi bi-globe"></i>
              <a href="https://bacoor.gov.ph" target="_blank" rel="noopener noreferrer">
                Bacoor Government Center
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Emergency Hotlines</h3>
          <ul>
            <li>Bacoor Disaster Risk Reduction and Management Office (BDRRMO): 161 or (046) 417-0727</li>
            <li>Philippine National Police-Bacoor City (PNP): 161 or (046) 417-6366</li>
            <li>Bureau of Fire Protection-Bacoor City (BFP): 161 or (046) 417-6060</li>
            <li>City Information Office: (046) 481-4120</li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 Explore Bacoor. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
